import apiInstance from "../api";
import { getResFromJWTToken } from "../utils/decodeJWTRes";

export const getHomePageData = async () => {
  try {
    const { data } = await apiInstance.get("/home");
    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const getDynamicPageData = async (slug: any, navigate: any) => {
  try {
    const pageSlug = slug.split("/")[1];
    const { data } = await apiInstance.get(`/page/${pageSlug}`);

    const resData: any = getResFromJWTToken(data);
    if (!resData?.data?.length) {
      navigate("/404");
    }
    return resData;
  } catch (error) {
    console.log(error);
  }
};

export const getSEOPageData = async (slug: any) => {
  const pageSlug = slug.split("/")[1];
  const { data } = await apiInstance.get(`/page/meta-data/${pageSlug}`);

  const resData: any = getResFromJWTToken(data);

  return resData;
};

export const getWidgetsPageData = async (slug: any) => {
  try {
    const pageSlug = slug.split("/")[1];
    const { data } = await apiInstance.get(`/widgets/${pageSlug}`);

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const getMagazinePageData = async () => {
  try {
    const { data } = await apiInstance.get(`e-magazine`);

    return getResFromJWTToken(data);
  } catch (error) {
    console.log(error);
  }
};

export const getContactUsPageData = async () => {
  try {
    const { data } = await apiInstance.get(`/contact`);

    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching contact us data:", error?.message);
  }
};

export const getDownloadPageData = async () => {
  try {
    const { data } = await apiInstance.get(`/download`);

    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getGallaryPageData = async () => {
  try {
    const { data } = await apiInstance.get(`/gallery`);
    const resData: any = getResFromJWTToken(data);

    return {
      data: resData?.data?.gallery?.galleryListing,
      sidebar: resData?.data?.widgets,
    };
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getAllCourses = async () => {
  try {
    const { data } = await apiInstance.get("/course");
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getAllCoursesCategory = async (slug: string) => {
  try {
    const { data } = await apiInstance.get(`/course/${slug}`);
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getAllCoursesByCategory = async (category: string) => {
  try {
    const { data } = await apiInstance.get(
      `/course/all-category?category=${category}`
    );
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getAllCoursesByLanguage = async (slug: string) => {
  try {
    const { data } = await apiInstance.get(`/course/language/${slug}`);
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getAllCoursesBySkill = async (slug: string) => {
  try {
    const { data } = await apiInstance.get(`/course/skill/${slug}`);
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getCourseDetailById = async (slug: string, token: string) => {
  try {
    const { data } = await apiInstance.get(`/course/detail/${slug}`, {
      headers: {
       ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
    });
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching course detail:", error?.message);
  }
};

export const getCourseReviewById = async (id: string) => {
  try {
    const { data } = await apiInstance.get(`review/course/${id}`);
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getVideoById = async (id: string) => {
  try {
    const { data } = await apiInstance.get(
      `${process.env.REACT_APP_PLAYBACK_URL}/playbackurl?assetId=${id}`
    );
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching video by id:", error?.message);
  }
};

export const getVideoWatchById = async (id: string, token: string) => {
  try {
    const { data } = await apiInstance.get(
      `${process.env.REACT_APP_PLAYBACK_URL}/bookmark?assetId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error videowatch by id:", error?.message);
  }
};

export const updateVideoWatchTime = async (videoData: any, token: string) => {
  try {
    const { data } = await apiInstance.post(
      `${process.env.REACT_APP_PLAYBACK_URL}/bookmark`,
      videoData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error update video watch time", error?.message);
  }
};

export const markVideoCompleted = async (lessonId: string, token: string) => {
  try {
    const { data } = await apiInstance.post(
      `/course/complete`,
      { lessonId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error update video watch time", error?.message);
  }
};

export const getMescVidyadaan = async () => {
  try {
    const { data } = await apiInstance.get(`/page/mesc-vidyadaan`);
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching header data:", error?.message);
  }
};

export const getOttPageData = async () => {
  try {
    const { data } = await apiInstance.get(`/ott`);
    return getResFromJWTToken(data);
  } catch (error: any) {
    console.error("Error fetching ott data:", error?.message);
  }
};
